import { Tooltip } from '@mui/material';

const BrainoTooltip = Tooltip;

  export default BrainoTooltip;